import { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('regen_user') || 'null'); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('regen_token');
    if (!token) { setLoading(false); return; }
    api.get('/auth/me').then(r => {
      setUser(r.data);
      localStorage.setItem('regen_user', JSON.stringify(r.data));
    }).catch(() => {
      localStorage.removeItem('regen_token');
      localStorage.removeItem('regen_user');
      setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    localStorage.setItem('regen_token', r.data.token);
    localStorage.setItem('regen_user', JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (data) => {
    const r = await api.post('/auth/register', data);
    localStorage.setItem('regen_token', r.data.token);
    localStorage.setItem('regen_user', JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem('regen_token');
    localStorage.removeItem('regen_user');
    setUser(null);
    window.location.href = '/';
  };

  const refresh = async () => {
    const r = await api.get('/auth/me');
    setUser(r.data);
    localStorage.setItem('regen_user', JSON.stringify(r.data));
    return r.data;
  };

  return <AuthCtx.Provider value={{ user, login, register, logout, refresh, loading }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
